import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { ReviewUnavailableModalProps } from '@/widgets/modals/types';

import { ModalContainerV1 } from '../containers/ModalContainerV1';

export const ReviewUnavailableModal: FC<ReviewUnavailableModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'reviewUnavailable' });

  return (
    <ModalContainerV1 title={t('title')}>
      <Text>{t('text')}</Text>
    </ModalContainerV1>
  );
};

const Text = styled.span`
  padding: 24px;
  font-size: 14px;
  color: ${COLORS.systemDark300};
`;
